import { Component } from '@angular/core';
import { EstadoCuenta } from 'src/app/models/estado-cuenta.interface';
import { AuthService } from 'src/app/services/auth.service';
import { EnfermeraService } from 'src/app/services/enfermera.service';
@Component({
  selector: 'app-enfermera-saldo',
  templateUrl: './enfermera-saldo.component.html',
  styleUrls: ['./enfermera-saldo.component.scss']
})
export class EnfermeraSaldoComponent {
  estadoCuenta: EstadoCuenta[] = [];

  constructor(
    private enfermeraService: EnfermeraService,
    private authService: AuthService) {

    if (this.authService.isLoggedIn) {
      const idEnfermera: number | undefined = this.authService.getUsuario?.enfermera?.id;
      if (idEnfermera) this.obtenerInformacion(idEnfermera);
    }

  }
  obtenerInformacion(id: number): void {
    this.enfermeraService.getEstadoCuenta(id)
      .subscribe({
        next: (resp) => { this.procesoEstadoCuenta(resp); console.log(resp) },
        error: (err) => { console.log(err) }
      });
  }
  procesoEstadoCuenta(estadocuenta: EstadoCuenta[]): void {
    for (let i in estadocuenta) {
      this.suma(parseInt(i), estadocuenta);
    }
    this.estadoCuenta.push(...estadocuenta);
  }
  suma(i: number, estadocuenta: EstadoCuenta[]): number {
    if ((estadocuenta.length - (i + 1)) == 0) {
      estadocuenta[i].saldo = estadocuenta[i].puntos - estadocuenta[i].canje;
      return estadocuenta[i].saldo;
    } else {
      estadocuenta[i].saldo = estadocuenta[i].puntos - estadocuenta[i].canje + this.suma(i + 1, estadocuenta);
      return estadocuenta[i].saldo;
    }
  }
}
